// utils/dateLimit.js
export function isDateWithin1Month(date) {
    const today = new Date();
    const d = new Date(date);
    const daysDiff = (today - d) / (1000 * 60 * 60 * 24);
    return daysDiff <= 31 && daysDiff >= 0;
  }